import axios from "axios";
import { SelectBox } from "devextreme-react";
import DataSource from "devextreme/data/data_source";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import userInfo from "../../common/Redux/userInfo";
import { updateSEQ } from "./Redux/workRecord";

export default function DetailedTaskDropDownBox(props) {
  const {
    detailedTaskDropDownBoxRef,
    // currentEmployeeNo
    currentEmployee,
  } = props;

  const [detailedTaskDataSource, setDetailedTaskDataSource] = useState(null);

  // const workRecord = useSelector((state) => state.workRecord);
  const classifWork = useSelector((state) => state.workRecord.classifWork);
  const contrNo = useSelector((state) => state.workRecord.contrNo);
  const codeNo = useSelector((state) => state.workRecord.codeNo);
  const SEQ = useSelector((state) => state.workRecord.SEQ);
  const subject = useSelector((state) => state.workRecord.subject);

  console.debug("SEQ", SEQ);

  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.userInfo);

  useEffect(async () => {
    // if (workRecord.codeNo && workRecord.codeNo.length > 0) {
    if (codeNo && codeNo.length > 0) {
      try {
        await axios
          .get(
            // `${process.env.REACT_APP_BECCO_API_URL}/api/workR/detailedTaskList/${workRecord.codeNo}`
            `${process.env.REACT_APP_BECCO_API_URL}/api/workR/detailedTaskList/${codeNo}`
          )
          .then((result) => {
            console.debug("detailedTask", result.data);

            setDetailedTaskDataSource(
              new DataSource({
                store: result.data,
                type: "array",
                key: "SEQ",
                sort: ["SEQ"],
              })
            );
          });
      } catch (error) {
        console.error(error);
      }
    }
    // }, [workRecord.contrNo, workRecord.codeNo]);
  }, [contrNo, codeNo]);

  const onValueChanged = (e) => {
    if (e.value && classifWork) {
      detailedTaskDropDownBoxRef.current.instance.option(
        "validationStatus",
        "valid"
      );

      dispatch(
        updateSEQ({
          SEQ: e.value,
          // subject: workRecord.subject
          //   ? workRecord.subject
          //   : e.component.option("selectedItem").detTask,
          previousValue: e.previousValue,
          // subject: subject
          //   ? subject
          //   : e.component.option("selectedItem").detTask,
          subject:
            e.value == "99" ? null : e.component.option("selectedItem").detTask,
          // descr: null,
        })
      );
    }
  };

  return (
    <SelectBox
      ref={detailedTaskDropDownBoxRef}
      dataSource={detailedTaskDataSource}
      displayExpr="detTask"
      valueExpr={"SEQ"}
      // value={workRecord.SEQ}
      value={SEQ}
      searchEnabled={true}
      searchMode="contains"
      searchExpr={"detTask"}
      searchTimeout={200}
      minSearchLength={0}
      showDataBeforeSearch={false}
      disabled={
        classifWork && (classifWork == 1 || classifWork == 2) && codeNo
          ? false
          : true
      }
      // readOnly={userInfo.employeeNo == currentEmployeeNo ? false : true}
      readOnly={
        userInfo.employeeNo == currentEmployee.employeeNo ? false : true
      }
      onValueChanged={onValueChanged}
    />
  );
}
